export default __webpack_public_path__ + "static/media/Tick.24de1e62.svg";